"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const OptGroup = props => {
  return _react.default.createElement("optgroup", {
    label: props.groupName
  }, props.children);
};
var _default = OptGroup;
exports.default = _default;